import { Injectable } from "@angular/core";
import { InAppPurchase } from "@ionic-native/in-app-purchase";
import { Platform } from "ionic-angular";

interface Product {
    currency: string;
    description: string;
    price: string;
    priceAsDecimal: number;
    productId: string;
    title: string;
}

@Injectable()
export class InAppPurchaseMock extends InAppPurchase {

    constructor(
        private platform: Platform,
    ) {
        super();
    }

    public getProducts(productId: string[]): Promise<Product[]> {
        let products: Product[] = [];

        if (this.platform.is('android')) {
            products.push({
                currency: 'EUR',
                description: 'Add a subscription to your account and unlock the full features of the app',
                price: '€7.99',
                priceAsDecimal: 7.99,
                productId: 'ie.ipa.directory.subscription.2019',
                title: '2020 Subscription',
            }, {
                currency: 'EUR',
                description: 'Add a subscription to your account and unlock the full features of the app',
                price: '€3.99',
                priceAsDecimal: 3.99,
                productId: 'ie.ipa.directory.promo_subscription.2019',
                title: '2020 Subscription (50% off)',
            });
        } else {
            products.push({
                currency: 'EUR',
                description: 'Subscribe to unlock all features of the app',
                price: '€7.99',
                priceAsDecimal: 7.99,
                productId: 'ie.ipa.directory.subscription.2019',
                title: '2020 Subscription (50% off)',
            }, {
                currency: 'EUR',
                description: 'Subscribe to unlock all features of the app',
                price: '€7.99',
                priceAsDecimal: 7.99,
                productId: 'ie.ipa.directory.promo.2019',
                title: '2020 Subscription',
            });
        }

        let matches = products.filter(product => {
            return productId.indexOf(product.productId) > -1;
        });

        return Promise.resolve(matches);
    }

}



// WEBPACK FOOTER //
// ./src/providers/mocks/in-app-purchase.ts